import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useModalState } from 'hooks/useModalState/useModalState';
import { deleteWantedTerminals } from 'api/wanted/wanted';

import { DeleteWantedTerminals } from './DeleteWantedTerminals';
import { DeleteWantedTerminalsContainerProps } from './DeleteWantedTerminals.types';

export const DeleteWantedTerminalsContainer = ({
  wantedId,
  checkedTerminals,
  setCheckedTerminals,
  terminalsCount,
}: DeleteWantedTerminalsContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const isMultiDelete = checkedTerminals.length > 1;

  const { mutate: onDeleteWantedTerminals, isLoading } = useMutation(deleteWantedTerminals, {
    onSuccess: (_, { body }) => {
      body.length > 1
        ? toast.dark(formatMessage({ id: AppMessages['wanted.terminals.delete.multi.success'] }))
        : toast.dark(formatMessage({ id: AppMessages['wanted.terminals.delete.single.success'] }));

      queryClient.invalidateQueries([QueryKeyEnum.WANTED_TERMINALS, wantedId]);
      queryClient.invalidateQueries([QueryKeyEnum.TERMINALS]);

      setCheckedTerminals([]);
      onModalClose();
    },
  });

  const onSubmit = () => {
    onDeleteWantedTerminals({
      id: wantedId,
      body: checkedTerminals.map(({ id }) => id),
    });
  };

  return (
    <DeleteWantedTerminals
      checkedTerminals={checkedTerminals}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
      isMultiDelete={isMultiDelete}
      terminalsCount={terminalsCount}
    />
  );
};
